<div [id]="id" class="resizable" cdkDrag [cdkDragDisabled]="!isDraggable || isCustomTagElementStatic" cdkDragBoundary=".page" (cdkDragStarted)="onDragStarted($event)" (cdkDragEnded)="onDragEnded($event)" (click)="selectSelf($event)"
  [class.resizable--comment-field]="isCommentOnly && !isCustomTagElement"
  [ngStyle]="{ left: left, top: top, height: isCustomTagElement ? '100%' : height, width: isCustomTagElement ? '100%' : width }">
  <div class="resizers"
    [ngClass]="{ 'resizers-comment-only sign-comment-container': isCommentOnly || isCustomTagElement }">
    <div class="sign-container" [ngClass]="{ 'custom-tag-container': isCustomTagElement }">
      @if(isCustomTagElement) {
      <div [class]="Constants.SIGN_COMMENT_CLASS">
        <ng-content select="[tag-content]"></ng-content>
      </div>
      } @else {
      @if(isCommentOnly) {
      <div [class]="Constants.SIGN_COMMENT_CLASS">
        <mat-form-field appearance="outline" data-type="COMMENT">
          <mat-label>{{ Constants.DEFAULT_COMMENT_PREFIX.replace('{ROLE}', signService.roleText) }}</mat-label>
          <textarea matInput [(ngModel)]="comment" placeholder="Enter Comment" [attr.data-value]="comment"
            ></textarea>
        </mat-form-field>
        <label class="sign-comment-suffix">{{
          Constants.DEFAULT_COMMENT_SUFFIX
          }}</label>
      </div>
      } @else {
      <img data-type="SIGNATURE" height="100%" width="100%" [src]="imageBase64" [attr.signatureId]="signatureId" alt=""
        resize />
      }
      <!-- @if(signComment) {
        <div class="sign-comment-container">
          <div class="sign-comment-prefix">Comment :&nbsp;</div>
          <div class="sign-comment">{{ signComment }}</div>
        </div>
        } -->
      }
    </div>
    <div class="resizer top-left"></div>
    <div class="resizer top-right"></div>
    <div class="resizer bottom-left"></div>
    <div class="resizer bottom-right"></div>
  </div>
  <div class="action-handles-container"
    [ngClass]="{
      'action-handles-bottom': !isCustomTagElement,
      'action-handles-custom-tag': isCustomTagElement && !isCustomTagElementStatic,
      'action-handles-comment-box': isCommentOnly && !isCustomTagElement
    }">
    <mat-icon color="warn" (click)="$event.stopPropagation(); $event.preventDefault(); onRemoveElement ? onRemoveElement() : destroyComponent()" matTooltip="Delete"
      [ngClass]="{ 'visibility-none': isCustomTagElementStatic || disableDelete }">delete</mat-icon>
    <mat-icon color="primary" class="drag-handle" cdkDragHandle matTooltip="Drag"
      [ngClass]="{ 'visibility-none': !isDraggable || isCustomTagElementStatic }">open_with</mat-icon>
  </div>

</div>
